module.exports = __webpack_public_path__ + "p5_img4.jpg?a477665e45415fdf62932f63df027558";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img4.jpg
// module id = 120
// module chunks = 0